angular.module('dpw.services').factory('mixpanelService', ['$q', '$timeout', 'dpwStorage', 'rcInternalUserIdentifier', function ($q, $timeout, dpwStorage, rcInternalUserIdentifier) {
    var service = {};
    var deferredLoading = $q.defer();
    var storageKeys = {
        SHOW_MIXPANEL_LOGS: 'showMixpanelLogs'
    };

    service.eventNames = {
        HOMEPAGE_VIEWED: 'Homepage Viewed',
        FREE_ACCOUNT_SIGNUP: 'Free Account Signup',
        SIGNUP_BUTTON_CLICK: 'Signup button click',
        CREATE_APP: 'Create App',
        GRADUATE_APP: 'Graduation: Success',
        PAGE_VIEW: 'Pageviews',
        API_CALL: 'API Call',
        AFTER_API_CALL: 'Docs: Try it out',
        DEV_FIRST_LOGIN: 'Dev: First Login',
        API_QUICK_START: 'API Quick Start',
        INVITE_NEW_USER: 'Invite New User',
        ACTION: 'Actions',
        TUTORIAL_SEARCH_BEHAVIOR: 'Tutorial Search Behavior',
        GRADUATION_REJECTED: 'Graduation: Rejected',
        GRADUATION_MODERATED: 'Graduation: Moderated',
        APPLY_FOR_PRODUCTION: 'Graduation: Submitted',
        APP_PROFILE_SUBMISSION: 'AG: Submitted',
        APP_PROFILE_APPROVAL: 'AG: Approved',
        APP_PROFILE_REJECT: 'AG: Rejected'
    };

    mixpanel.init(RCDPW.mixpanelToken || '97bf9fa67f079d8393dfda05418496c8', {
        autotrack: false,
        persistence: 'localStorage',
        cross_subdomain_cookie: false,
        loaded: function (mixpanel) {
            deferredLoading.resolve(mixpanel);
        }
    });

    RCDPW.showMixpanelLogs = function (show) {
        show = show !== false;
        dpwStorage.setItem(storageKeys.SHOW_MIXPANEL_LOGS, show);
    };

    service.isLoaded = deferredLoading.promise;

    service.track = function (eventName, properties) {
        if (showMixpanelLogs()) {
            console.log('Mixpanel -> Send Event "' + eventName + '"', '\nProperties:', properties);
        }

        return mixpanel.track(eventName, properties);
    };

    service.trackPageView = function (pageName) {
        var properties = {
            'Page Name': pageName,
            'Medium': 'web',
        };
        service.track(service.eventNames.PAGE_VIEW, properties);
    };

    service.performTracking = function (eventName, properties) {
        var hasMovedOn = false;

        return $q(function (resolve) {
            if (showMixpanelLogs()) {
                console.log('Mixpanel -> Send Event "' + eventName + '"', '\nProperties:', properties);
            }

            $timeout(moveOnNext, 3000);
            mixpanel.track(eventName, properties, moveOnNext);

            function moveOnNext() {
                if (!hasMovedOn) {
                    hasMovedOn = true;
                    resolve();
                }
            }
        });
    };

    service.track_links = function (selector, eventName, properties) {
        return mixpanel.track_links(selector, eventName, function () {
            if (showMixpanelLogs()) {
                console.log('Mixpanel -> Send Event "' + eventName + '"', '\nProperties:', properties);
            }
            return properties;
        });
    };

    service.register = function (superProperties) {
        if (showMixpanelLogs()) {
            console.log('Mixpanel -> Register super property.', '\nSuper properties:', superProperties);
        }

        return mixpanel.register(superProperties);
    };

    service.alias = function (developer) {
        var rcExtensionId = developer.rcExtensionId;
        var email = developer.email;

        if (showMixpanelLogs()) {
            console.log('Mixpanel -> Map alias to distinct_id.', '\nRC extension ID:', rcExtensionId, '\nEmail:', email);
        }

        mixpanel.alias(rcExtensionId);
        service.resolveOptInOutStatus(email);
    };

    service.identify = function (developer) {
        var rcExtensionId = developer.rcExtensionId;
        var email = developer.email;

        if (showMixpanelLogs()) {
            console.log('Mixpanel -> Identify user.', '\nRC extension ID:', rcExtensionId, '\nEmail:', email);
        }

        mixpanel.identify(rcExtensionId);
        service.resolveOptInOutStatus(email);
    };

    service.set_group = function (hashedAccountId) {
        var hasMovedOn = false;

        return $q(function (resolve) {
            if (showMixpanelLogs()) {
                console.log('Mixpanel -> Set group.', '\nhashed_rc_account_id:', hashedAccountId);
            }

            $timeout(moveOnNext, 3000);
            mixpanel.set_group('hashed_rc_account_id', hashedAccountId, moveOnNext);

            function moveOnNext() {
                if (!hasMovedOn) {
                    hasMovedOn = true;
                    resolve();
                }
            }
        });
    }

    service.setPeopleProperty = function (properties) {
        var hasMovedOn = false;

        return $q(function (resolve) {
            if (showMixpanelLogs()) {
                console.log('Mixpanel -> Set people property.', '\nProperties:', properties);
            }

            $timeout(moveOnNext, 3000);
            mixpanel.people.set(properties, moveOnNext);

            function moveOnNext() {
                if (!hasMovedOn) {
                    hasMovedOn = true;
                    resolve();
                }
            }
        });
    };

    service.reset = function () {
        if (showMixpanelLogs()) {
            console.log('Mixpanel -> Reset.');
        }

        mixpanel.reset();
    };

    service.getDistinctId = function () {
        return this.isLoaded.then(function (mixpanel) {
            return mixpanel.get_distinct_id();
        });
    };

    service.getProperty = function (name) {
        return this.isLoaded.then(function (mixpanel) {
            return mixpanel.get_property(name);
        });
    };

    service.resolveOptInOutStatus = function (email) {
        var shouldOptOut = service.isInternalUser(email);
        service.optUserOut(shouldOptOut);
    };

    service.isUserOptedOut = function () {
        return this.getProperty('$ignore');
    };

    service.optUserOut = function (shouldOptOut) {
        service.register({
            '$ignore': shouldOptOut
        });
    };

    service.isInternalUser = function (email) {
        return rcInternalUserIdentifier.emailPatterns.some(function (re) {
            return re.test(email);
        });
    };

    return service;

    function showMixpanelLogs() {
        return dpwStorage.getItem(storageKeys.SHOW_MIXPANEL_LOGS) === 'true';
    }
}]);
